export const checkFeatureFlag = (flagName) => {
  if (typeof posthog === "undefined") {
    return false;
  }

  return posthog.isFeatureEnabled(flagName);
};

export const getFeatureFlag = (flagName) => {
  if (typeof posthog === "undefined") {
    return;
  }

  return posthog.getFeatureFlag(flagName);
};
